import React, { useState, useRef, useEffect } from "react";
import { FaPlay, FaPause } from "react-icons/fa";
import "./AudioPlayer.css";

const AudioPlayer = ({ src }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  const audioRef = useRef(null);

  useEffect(() => {
    const audio = audioRef.current;

    audio.addEventListener("loadedmetadata", handleLoadedMetadata);
    audio.addEventListener("timeupdate", updateTime);

    return () => {
      audio.removeEventListener("loadedmetadata", handleLoadedMetadata);
      audio.removeEventListener("timeupdate", updateTime);
    };
  }, []);

  const handleLoadedMetadata = () => {
    const audio = audioRef.current;
    const audioDuration = audio.duration;

    if (!isNaN(audioDuration) && audioDuration !== Infinity) {
      setDuration(audioDuration);
    } else {
      setDuration(0);
    }
  };

  const togglePlayPause = () => {
    const audio = audioRef.current;
    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
    setIsPlaying(!isPlaying);
  };

  const updateTime = () => {
    setCurrentTime(audioRef.current.currentTime || 0);
    setDuration(audioRef.current.duration || 0);
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
  };

  const progress = duration ? (currentTime / duration) * 100 : 0;

  return (
    <div className="audio-player">
      <button className="play-pause-btn" onClick={togglePlayPause}>
        {isPlaying ? (
          <FaPause title="Pause Audio" size={15} color="white" />
        ) : (
          <FaPlay title="Play Audio" size={15} color="white" />
        )}
      </button>
      <div className="waveform">
        <div className="progress-bar" style={{ width: `${progress}%` }}></div>
      </div>
      <div className="time">
        {formatTime(currentTime)} /{" "}
        {isNaN(duration) || duration === Infinity
          ? "0:00"
          : formatTime(duration)}
      </div>
      <audio
        ref={audioRef}
        preload="auto"
        src={src}
        onTimeUpdate={updateTime}
        onLoadedMetadata={updateTime}
        onEnded={() => setIsPlaying(false)}
      ></audio>
    </div>
  );
};

export default AudioPlayer;
